import { CustomAddress } from '../../interfaces/address.interface';
import { BaseModel } from '../_base/model.class';
import { UserRole } from './user.interface';

export class User extends BaseModel {
  constructor(
  private _id?: string,
  private roles?: any[],
  private userRoles?: UserRole[],
  private email?: string,
  private password?: string,
  private firstName?: string,
  private lastName?: string,
  private taxCode?: string,
  private address?: CustomAddress,
  private phone?: string,
  private active?: boolean,
  private originalPassword?: boolean,
  private properties?: any,
  private updatedAt?: Date,
  private updatedBy?: string,
  private createdAt?: Date,
  private createdBy?: string,
  private videoSecurity?: boolean,
  private videoSecurityDate?: Date,
  private hideHomePopup?: boolean,
  ) {
    super();

    this.setRequiredFields([
      '_id',
      'roles',
      // 'userRoles',
      'email',
      'password',
      'firstName',
      'lastName',
      'taxCode',
      'address',
      'phone',
      'active',
      'originalPassword',
      'createdAt',
      'createdBy',
    ]);
  }

  /**
   * Check if user is active or not
   *
   * @since 1.0.0
   */
  isActive(): boolean {
    return this.active;
  }

  /**
   * Check if user has the original password
   *
   * @since 1.0.0
   */
  isOriginalPassword(): boolean {
    return this.originalPassword;
  }
}
